import Vue from 'vue';
import types from './mutation-types';

const mutations = {
  [types.UPDATE_CL_EVENT](state, { eventName, value }) {
    Vue.set(state.clEvents, eventName, value);
  },

  [types.SET_CL_EVENTS](state, clEvents) {
    Vue.set(state, 'clEvents', clEvents);
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/cl-events/store/mutations.js